<template>
<v-bottom-sheet v-model="dialogWebviewbig" scrollable persistent style="overflow-x: hidden; border-radius:20px;" :fullscreen="fullscreen">
  <v-sheet :height="heightWeb">
    <v-card tile>
      <v-app-bar flat style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai">&nbsp;&nbsp;{{Webview_item.label}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon text @click.native="newtab">
          <v-icon style="color: white !important; font-size: 20px !important;">far fa-window-restore</v-icon>
        </v-btn>
        <v-btn dark icon text @click.native="closeDialog">
          <v-icon style="color: white !important; font-size: 20px !important;">mdi-close</v-icon>
        </v-btn>
      </v-app-bar>
    </v-card>
    <v-card-text class="chat-container">
      <!-- <p>url: {{Webview_item.url}}</p> -->
      <iframe style="visibility:visible; width: 100vw; height: 100vh;" frameborder='0' allowfullscreen :src="Webview_item.url" allow="geolocation;clipboard-read; clipboard-write" v-if="!progressLoding"></iframe>
      <v-layout wrap v-else>
        <v-flex sm12 md12 lg12 xl12 style="justify-content: center; display: grid;height: 80vh;">
          <div style="margin: auto;">
            <h3 style="text-align: center;">กรุณารอซักครู่ ระบบกำลังประมวลผล</h3>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-sheet>
</v-bottom-sheet>
</template>
<script>
import {
  sync
} from 'vuex-pathify'
export default {
  props: {
    dialogWebviewbig: false,
    Webview_item: {},
    tokenroom: String,
    tokenuser: String
  },
  data() {
    return {
      heightWeb: '100vh',
      progressLoding: true,
      fullscreen: false,
    }
  },
  watch: {
    socket_close_webview() {
      this.closeDialog()
    },
    dialogWebviewbig () {
      // console.log(this.dialogWebviewbig)
      if (this.dialogWebviewbig) {
        if (this.Webview_item.size === 'compact') {
          this.heightWeb = '65vh'
          this.fullscreen = false
        } else if (this.Webview_item.size === 'tall') {
          this.heightWeb = '80vh'
          this.fullscreen = false
        } else {
          this.heightWeb = '100vh'
          this.fullscreen = true
        }
      }
    },
    Webview_item() {
      if (this.Webview_item.url) {
        // console.log(this.Webview_item)
        this.progressLoding = false
      }
    }
  },
  computed: {
    ...sync('*')
  },
  methods: {
    closeDialog() {
      this.$emit('closeWebview', false)
      this.progressLoding = true
      this.closewebview()
    },
    newtab() {
      window.open(this.Webview_item.url, '_blank')
      this.closeDialog()
    },
    closewebview() {
      // console.log(authen.tokenuser)
      this.axios.post(process.env.VUE_APP_API_alpine + `/v1/close-webview`, {
        tokenroom: this.tokenroom,
        tokenuser: this.tokenuser
      }).then((response) => {
        // console.log(response.data)
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>
<style type="text/css" scoped>
.chat-container {
    box-sizing: border-box;
    height: calc(100vh - 250px) !important;
    /* height: calc(100vh - 70px) !important; */
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    padding: 0px;
  }

.chat-container::-webkit-scrollbar-thumb {
  background: #888 !important;
  border-radius: 10px;
  background-clip: padding-box !important;
}

.chat-container::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
</style>
